// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_ListTicketsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for listing Odoo tickets
 *
 * Response envelope:
 * {
 *   "success": true,
 *   "dados": {
 *     "tickets": [...],
 *     "total": 10
 *   },
 *   "error": null
 * }
 */
import type { OdooTickets_ListTicketsRow } from './OdooTickets_ListTicketsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_ListTicketsResponseDados {
tickets: OdooTickets_ListTicketsRow[]
total: number
}

export type OdooTickets_ListTicketsResponse = ApiResponse<OdooTickets_ListTicketsResponseDados>;

registerResponseContract('OdooTickets_ListTicketsResponse', {
  tickets: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: true },
      description:      { type: 'string',  required: true },
      user_description: { type: 'string',  required: true },
      description_raw:  { type: 'string',  required: true },
      stage_name:       { type: 'string',  required: true },
      status:           { type: 'string',  required: true },
      status_id:        { type: 'number',  required: true },
      created_at:       { type: 'string',  required: true },
      updated_at:       { type: 'string',  required: true },
      priority:         { type: 'string',  required: false },
      assigned_to:      { type: 'string',  required: false },
      page_uri:         { type: 'string',  required: false },
    },
  },
  total:   { type: 'number',  required: true },
})
